import React from 'react'
import styled from '@emotion/styled'
import Modal from '../../layout/Modal'
import { breakpoints } from '../../../constants'
import { fontSizeSmall, fontSize3XSmall } from '../../../constants/principles'

export default ({ name, title, subtitle, children, lessPadding = false, maxWidth, minHeight, open, dependencyList = [], closeOnClickOutside = true, testId }) => (
  <Modal name={name} open={open} dependencyList={dependencyList} closeOnClickOutside={closeOnClickOutside}>
    <Ie11Wrapper data-testid={testId ? testId : ''}>
      <ModalSize maxWidth={maxWidth} minHeight={minHeight}>
        <ModalTitle data-testid={`${testId ? testId : ''}-title`}>{title}</ModalTitle>
        <ModalSubtitle data-testid={`${testId ? testId : ''}-subtitle`} padding={lessPadding && 0}>{subtitle}</ModalSubtitle>
        {children}
      </ModalSize>
    </Ie11Wrapper>
  </Modal>
)

const ModalSize = styled.div`
  ${p => p.subtitle && `padding-bottom:16px;`}
  width: 60vw;
  min-width: 312px;
  max-width: ${p => (p.maxWidth ? p.maxWidth : 700)}px;
  min-height: ${p => (p.minHeight ? p.minHeight : 300)}px;
  max-height: 600px;
  @media (max-height: 600px) {
    max-height: 90vh;
  }
  display: flex;
  flex-direction: column;
  padding: 24px;
  @media (max-width: ${breakpoints.lg}px) {
    padding: 16px;
  }
`
const ModalTitle = styled.h2`
  margin: 0px;
  font-size: ${fontSizeSmall};
`
const ModalSubtitle = styled.div`
  font-size: ${fontSize3XSmall};
  font-weight: ${p => p.fontWeight};
  color: ${p => p.fontColor};
  padding-bottom: ${p => (p.padding || p.padding === 0 ? p.padding : 16)}px;
`
const Ie11Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`
